import {createStore} from 'vuex'

export default createStore({
    state: {
        isLoading: undefined,
        brandConfig: undefined,
        user: undefined,
        msisdn: undefined,
        urlParameters : undefined,
    },
    getters: {},
    mutations: {
        setIsLoading(state, isLoading) {
            state.isLoading = isLoading
        },
        setBrandConfig(state, brandConfig) {
            state.brandConfig = brandConfig
        },
        setUser(state, user) {
            state.user = user
        },
        setMsisdn(state, msisdn) {
            state.msisdn = msisdn
        },
        setUrlParameters(state, urlParameters) {
            state.urlParameters = urlParameters
        },
    },
    actions: {},
    modules: {}
})
